import { BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ThemeChart = ({ data, chartType, onThemeClick }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: 'var(--on--300)' }}>
        No data available for the selected period
      </div>
    );
  }

  if (chartType === 'pie') {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            cx="35%"
            cy="50%"
            labelLine={false}
            label={({ percentage }) => percentage ? `${percentage}%` : ''}
            outerRadius={120}
            fill="#8884d8"
            dataKey="value"
            onClick={(data, index) => {
              if (onThemeClick && data.name) {
                onThemeClick(data.name);
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="middle" align="right" layout="vertical" />
        </PieChart>
      </ResponsiveContainer>
    );
  }

  // Bar chart (default)
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis dataKey="name" type="category" width={150} />
        <Tooltip 
          formatter={(value, name) => [value, 'Count']}
          labelFormatter={(label) => `Theme: ${label}`}
        />
        <Bar 
          dataKey="value"
          onClick={(data) => {
            if (onThemeClick && data.name) {
              onThemeClick(data.name);
            }
          }}
          style={{ cursor: 'pointer' }}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ThemeChart;

